import React, { Component } from 'react';
import Styles from '@src/framework/editor/src/page/index/components/editor/index.less';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import i18n from '@i18next/i18n';
import DropDownMenu from './drop-down-menu';
import { CANVAS_WRAPPER } from '@src/slide/content-viewer/service/canvas-renderer/core/id-constants';
import { LINK_HEIGHT } from '@src/js/constant';

interface DropDownProps {
    config: {
        tipText: string;
        items: { id: string; name?: string }[];
    };
    onSelectedItemCallback: (mode: any) => void;
    isDropDownExtendShow: boolean;
    hideDropDownMenu: () => void;
    showDropDownMenu: () => void;
    getModeFromConfigData: () => string;
}

class DropDown extends Component<DropDownProps> {
    private menuComponent: HTMLDivElement | null = null;

    public componentWillUnmount() {
        this.props.hideDropDownMenu();
    }

    public componentDidUpdate() {
        if (this.props.isDropDownExtendShow && this.menuComponent) {
            const dropRect = this.menuComponent.getBoundingClientRect();
            const c = document.getElementById(CANVAS_WRAPPER);
            const bound = c!.getBoundingClientRect();
            if (dropRect.bottom > bound.bottom) {
                this.menuComponent.style.transform = `translateY(${0 - dropRect.height - LINK_HEIGHT}px)`;
            }
        }
    }

    public render() {
        const { config } = this.props;
        const displayMode = this.props.getModeFromConfigData();
        return (
            <div className={Styles['link-floatbar-v2-dropdown-button-container']}>
                {
                    <Tooltip placement="top" title={i18n.t(config.tipText)}>
                        <div className={Styles['link-floatbar-v2-dropdown-button-wrapper']}
                            onMouseUp={this.onMouseUp}
                        >
                            <div className={Styles[`link-floatbar-v2-dropdown-button-${displayMode}`]}/>
                            <div className={Styles['link-floatbar-v2-menu-button-dropdown']}/>
                        </div>
                    </Tooltip>
                }
                {this.props.isDropDownExtendShow ? <div className={Styles['link-floatbar-v2-dropdown-menu-wrapper']} ref={(ref) => {
                    this.menuComponent = ref;
                } }>
                    <DropDownMenu
                        items={config.items}
                        displayMode={displayMode}
                        onSelectedItemCallback={this.handleSelectItemCallback}
                    />
                </div> : ''}
            </div>
        );
    }
    private handleSelectItemCallback = (mode) => {
        this.props.onSelectedItemCallback(mode);
    };
    private onMouseUp = () => {
        if (this.props.isDropDownExtendShow) {
            this.props.hideDropDownMenu();
        } else {
            this.props.showDropDownMenu();
        }
    };
}

export default DropDown;
